<template>
  <div :class="fixed ? 'contact-wrapper fixed' : 'contact-wrapper'">
    <div :class="isWhite ? 'contact-content white' : 'contact-content' " @click="handleShow">
      <img
        :src="isWhite ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220331/c273ccec8fd12c13178155eb5c89f628.png' : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/45ea65650eb4f0e8b20d34b082f0e5f3.png'"
        alt=""
      />
      联系客服
    </div>
    <ContactImg :visible="show" @hideVisible="handleShow()" />
  </div>
</template>

<script>
import ContactImg from '@/components/contactImg'
import { showServiceAble } from "@/utils/common";
export default {
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async handleShow() {
      let res = await showServiceAble();
      if(res) {
        this.show = !this.show;
      }
    }
  },
  components: {ContactImg}
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.contact-wrapper {
  text-align: center;
  padding: rem(30) 0;
}
.contact-wrapper.fixed{
  position: fixed;
  bottom:  0;
  left: 0;
  right: 0;
  z-index: 20000;
}
.contact-content{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: rem(28);
  cursor: pointer;
}
.contact-content.white{
  color: #ffffff;
}
.contact-content img {
  width: rem(30);
  height: rem(30);
  margin-right: rem(13);
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue